/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateListRequest {
    getFixupPrototypeFunction() { return AutomationTemplateListRequest.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateListRequest>): AutomationTemplateListRequest {
        let obj = Object.assign(new AutomationTemplateListRequest(), model);
        AutomationTemplateListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateListRequest>): AutomationTemplateListRequest {
        if (!model) return null;
        return AutomationTemplateListRequest.newInstance(<AutomationTemplateListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateListRequest) {
        if (!obj) return;

        models.AutomationTemplateListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateListRequest): boolean {
        Object.setPrototypeOf(obj, AutomationTemplateListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AutomationTemplateFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AutomationTemplateSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AutomationTemplateSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AutomationTemplateFilters;

}
